// extracted by mini-css-extract-plugin
export default {"container":"orders_container__XSJvQ","wrapper":"orders_wrapper__BPnCM","archiveCheck":"orders_archiveCheck__uOxuq"};